var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 6.3094C52.4752 4.88034 55.5248 4.88034 58 6.3094L96.7654 28.6906C99.2406 30.1197 100.765 32.7607 100.765 35.6188V80.3812C100.765 83.2393 99.2406 85.8803 96.7654 87.3094L58 109.691C55.5248 111.12 52.4752 111.12 50 109.691L11.2346 87.3094C8.75942 85.8803 7.23463 83.2393 7.23463 80.3812V35.6188C7.23463 32.7607 8.75942 30.1197 11.2346 28.6906L50 6.3094Z",
    fill: "#F9FAFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_153_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 11.7321C52.8564 10.6603 55.1436 10.6603 57 11.7321L92.5692 32.268C94.4256 33.3397 95.5692 35.3205 95.5692 37.4641V78.5359C95.5692 80.6795 94.4256 82.6603 92.5692 83.732L57 104.268C55.1436 105.34 52.8564 105.34 51 104.268L15.4308 83.732C13.5744 82.6603 12.4308 80.6795 12.4308 78.5359V37.4641C12.4308 35.3205 13.5744 33.3397 15.4308 32.268L51 11.7321Z",
    fill: "url(#paint0_linear_153_10)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_153_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.15 30.5041C52.8291 28.8506 55.1709 28.8506 55.85 30.5041L61.0933 43.2695C61.4389 44.111 62.3088 44.6132 63.2103 44.4918L76.8871 42.6499C78.6587 42.4113 79.8296 44.4393 78.7372 45.8542L70.3036 56.7778C69.7477 57.4978 69.7477 58.5022 70.3036 59.2222L78.7372 70.1458C79.8296 71.5607 78.6587 73.5887 76.8871 73.3501L63.2103 71.5082C62.3088 71.3868 61.4389 71.889 61.0933 72.7305L55.85 85.4959C55.1709 87.1494 52.8291 87.1494 52.15 85.4959L46.9067 72.7305C46.5611 71.889 45.6912 71.3868 44.7897 71.5082L31.1128 73.3501C29.3413 73.5887 28.1704 71.5607 29.2628 70.1458L37.6964 59.2222C38.2523 58.5022 38.2523 57.4978 37.6964 56.7778L29.2628 45.8542C28.1704 44.4393 29.3413 42.4113 31.1129 42.6499L44.7897 44.4918C45.6912 44.6132 46.5611 44.111 46.9067 43.2695L52.15 30.5041Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0752 30.8838C53.4149 30.0574 54.5851 30.0574 54.9248 30.8838L60.168 43.6494C60.6864 44.9115 61.9915 45.6645 63.3438 45.4824L77.0205 43.6406C77.9063 43.5213 78.4915 44.5357 77.9453 45.2432L69.5117 56.167C68.6783 57.2469 68.6783 58.7531 69.5117 59.833L77.9453 70.7568C78.4915 71.4643 77.9063 72.4787 77.0205 72.3594L63.3438 70.5176C61.9915 70.3355 60.6864 71.0885 60.168 72.3506L54.9248 85.1162C54.5851 85.9426 53.4149 85.9426 53.0752 85.1162L47.832 72.3506C47.3136 71.0885 46.0085 70.3355 44.6562 70.5176L30.9795 72.3594C30.0937 72.4787 29.5085 71.4643 30.0547 70.7568L38.4883 59.833C39.3217 58.7531 39.3217 57.2468 38.4883 56.167L30.0547 45.2432C29.5085 44.5357 30.0937 43.5213 30.9795 43.6406L44.6562 45.4824C46.0085 45.6645 47.3136 44.9115 47.832 43.6494L53.0752 30.8838Z",
    stroke: "url(#paint1_linear_153_10)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_153_10",
    x: 12.4308,
    y: 10.9282,
    width: 83.1384,
    height: 94.1436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_153_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_153_10",
    x: 28.8402,
    y: 29.264,
    width: 50.3196,
    height: 61.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_153_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_153_10",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_10",
    x1: 91.8947,
    y1: 12.7429,
    x2: 9.8865,
    y2: 88.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F95370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_153_10",
    x1: 79.2632,
    y1: 27.8286,
    x2: 24.591,
    y2: 78.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72439A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F95370"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlayer);
export default __webpack_public_path__ + "static/media/pro-player.55442de40433d91489982346cf33e383.svg";
export { ForwardRef as ReactComponent };